import basic from "./basic";
import close from "./close";
import cry from "./cry";
import dizzy from "./dizzy";
import eyeRoll from "./eye-roll";
import happy from "./happy";
import hearts from "./hearts";
import side from "./side";
import squint from "./squint";
import surprised from "./surprised";
import winkWacky from "./wink-wacky";
import wink from "./wink";

export default {
	basic,
	close,
	cry,
	dizzy,
	eyeRoll,
	happy,
	hearts,
	side,
	squint,
	surprised,
	winkWacky,
	wink,
};



// WEBPACK FOOTER //
// ./src/face/eyes/index.js